<template>
  <svg
    class="ui-base-icon"
    :class="[
      size && `ui-base-icon-${size}`,
      {
        'jps-icon-spin': isSpin,
        'is-ko-icon': isKoIcon,
      },
    ]"
    :aria-hidden="alt ? undefined : 'true'"
    role="img"
    :viewBox="svgSizes[name] || '0 0 24 24'"
  >
    <title v-if="alt">{{ alt }}</title>
    <use :href="`/assets/img/icons/${props.name}.svg#icon`"></use>
  </svg>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'
import { svgSizes } from '~/components/icons'
type Props = {
  name: SVG_NAMES
  alt?: string
  size?: `size-${number}` | 'size-full' | 'size-none'
  isSpin?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  alt: '',
  size: 'size-4',
  isSpin: false,
})

const isKoIcon = computed(() => props.name.startsWith('koicon'))
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-base-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.jps-icon-spin {
    animation: icon-spin 2s infinite linear;
    @keyframes icon-spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(359deg);
      }
    }
  }
}

.ui-base-icon-size-full {
  width: 100%;
  height: 100%;
}

.ui-base-icon-size-1 {
  width: $size-1;
  height: $size-1;
}

.ui-base-icon-size-2 {
  width: $size-2;
  height: $size-2;
}

.ui-base-icon-size-3 {
  width: $size-3;
  height: $size-3;
}

.ui-base-icon-size-4 {
  width: $size-4;
  height: $size-4;
}

.ui-base-icon-size-5 {
  width: $size-5;
  height: $size-5;
}

.ui-base-icon-size-6 {
  width: $size-6;
  height: $size-6;
}

.ui-base-icon-size-7 {
  width: $size-7;
  height: $size-7;
}

.ui-base-icon-size-8 {
  width: $size-8;
  height: $size-8;
}

.is-ko-icon {
  color: #D30C2F;
}
</style>
